// src/components/StepIndicator.js
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function StepIndicator({ current }) {
  const { t } = useTranslation();

  const STEPS = [
    t('steps.cropping'),
    t('steps.backgroundRemoval'),
    t('steps.resizing'),
    t('steps.analyzing'),
  ];

  return (
    <ul style={styles.list}>
      {STEPS.map((label, i) => {
        const isDone = i < current;
        const isActive = i === current;
        return (
          <li key={i} style={styles.item}>
            <span
              style={{
                ...styles.icon,
                ...(isDone && styles.doneIcon),
                ...(isActive && styles.activeIcon),
              }}
            >
              {isDone ? '✓' : isActive ? i + 1 : i + 1}
            </span>
            <span
              style={{
                ...styles.label,
                ...(isDone && styles.doneLabel),
                ...(isActive && styles.activeLabel),
              }}
            >
              {label}
            </span>
          </li>
        );
      })}
    </ul>
  );
}

const styles = {
  list: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 16px',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
  },
  icon: {
    display: 'inline-block',
    width: '24px',
    height: '24px',
    lineHeight: '24px',
    borderRadius: '50%',
    border: '2px solid #ccc',
    textAlign: 'center',
    marginRight: '8px',
    color: '#888',
    fontWeight: 'bold',
  },
  doneIcon: {
    backgroundColor: '#5cb85c',
    borderColor: '#5cb85c',
    color: 'white',
  },
  activeIcon: {
    backgroundColor: '#444',
    borderColor: '#444',
    color: 'white',
  },
  label: {
    color: '#bbb',
    fontSize: '14px',
  },
  doneLabel: {
    color: '#5cb85c',
  },
  activeLabel: {
    color: '#222',
    fontWeight: 'bold',
  },
};
